import { EIcons } from '@/components/atoms/at-icon/icons';

export const mlInfoTooltipMockData = {
  iconName: EIcons.INFO,
  body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, urna at tincidunt cursus, nisi nunc fermentum quam, nec lacinia sapien libero nec justo. Nulla facilisi. In hac habitasse platea dictumst. Donec scelerisque, sapien vel fermentum pharetra, erat eros tincidunt urna, in porttitor est ligula sit amet orci. <a href="/" target="_self">Learn more here</a>',
};
